import { Observable } from "rxjs";
import { httpUtils } from "src/infra/http/utils";
import { inject, injectable } from "tsyringe";

import { LifeEndpoints } from "src/containers/life/constants/endpoints";
import { autoBind } from "src/shared/decorators/autobind";
import { HttpClient } from "src/infra/http/client";
import { replaceString } from "src/libs/replace-string";
import { PgaPolicy } from "src/shared/models/pga-policy.model";

@injectable()
export class LifeRepository {
    constructor(@inject("HttpClient") private http: HttpClient) {}

    @autoBind
    getInfo(userIdentity: string, policy: PgaPolicy): Observable<object> {
        const url = replaceString(LifeEndpoints.GetInfo, {
            ":userIdentity": userIdentity,
            ":policyId": policy.id,
        });
        return this.http.getJSON<Record<string, any>>(url, {
            isPublicRequest: false,
            params: {
                "system-code": policy.product.systemCode,
            },
            customHeader: {
                ...httpUtils.getBaseHeaders(),
                ...httpUtils.getMsBaseHeaders(userIdentity, "MEP"),
            },
        });
    }
}
